import { Logger } from "shared/lib/Logger"
import { ProductPosition } from "shared/types/ProductPosition"

import { ProductPositionSchemaTransform } from "../types/ProductPosition"

export function getProductPositionComplete({
  productPosition
}: {
  productPosition: ProductPosition
}): Required<ProductPosition> | undefined {
  const result = ProductPositionSchemaTransform.safeParse(productPosition)

  if (!result.success) {
    Logger.error(
      "ValidationError",
      "unable to create optimistic response while creating product position",
      {
        errors: result.error.issues,
        productPosition
      }
    )
    return undefined
  }

  return result.data
}
